export const checkDigitOnly = (event, allowSlash = false) => {
    let code = event.which ? event.which : event.keyCode;
    if (allowSlash && code === 111) return true;
    if (code < 48 || code > 57) {
        return false;
    }
    return true;
};

const nonDigitsRegexp = /[\D]+/g;
export const keepOnlyDigits = value => value.replace(nonDigitsRegexp, '');

export const formatCreditCardNumber = value => {
    let v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    let matches = v.match(/\d{4,19}/g);
    let match = (matches && matches[0]) || '';
    let parts = [];

    for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
    }

    if (parts.length) {
        return parts.join(' ');
    } else {
        return value;
    }
};

export const findCardType = (cardNumber, cardTypes) => {
    for (const cardType of cardTypes) {
        for (const prefix of cardType.iin_prefixes) {
            if (cardNumber.indexOf(prefix) === 0) {
                return cardType;
            }
        }
    }
    return null;
};

export const findTokenizer = (cardType, tokenizers) => {
    for (const tokenizer of tokenizers) {
        if (tokenizer.card_types.indexOf(cardType) >= 0) {
            return tokenizer;
        }
    }
    return null;
};

export const luhnValidate = cardNumber => {
    const length = cardNumber.length;
    let odd = false,
        total = 0,
        resOdd,
        resEven;
    for (let i = length; i > 0; i--) {
        resOdd = parseInt(cardNumber.charAt(i - 1));
        if (!odd) {
            total += resOdd;
        } else {
            resEven = resOdd * 2;

            switch (resEven) {
                case 10:
                    resEven = 1;
                    break;
                case 12:
                    resEven = 3;
                    break;
                case 14:
                    resEven = 5;
                    break;
                case 16:
                    resEven = 7;
                    break;
                case 18:
                    resEven = 9;
                    break;
                default:
                    break;
            }
            total += resEven;
        }
        odd = !odd;
    }

    return total !== 0 && total % 10 === 0;
};